import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import { IBetData } from "../../../core/src/server/data/IBetData";

export default class BalanceDataParser implements IBaseDataParser<IBetData> {
    check(data: { balance: number }): boolean {
        return !!data?.balance;
    }
    parse(data: { balance: number }): IBetData | IBetData[] {
        // TODO: what's that???
        // let betStatesData : { [bet: number]: {[propName:string]:any} } = {};
        // if(data.data.gameData.userState) {
        //     data.data.gameData.userState.forEach(element => {
        //         betStatesData[element.bet] = element.data;
        //     });

        // }

        let result: IBetData = {
            balance: data.balance,
            // betStatesData
        };

        return result;
    }
}
